<template>
  <div>
    <div class="qr">
      <div class="title">{{$t('shareQr')}}</div>
      <img :src="qrImage" alt="">
    </div>
    <div class="url-wrap">
      <div class="title">{{$t('shareLink')}}：</div>
        <div class="url">
          {{`${apiBaseUrl}web/?invite=${invite}`}} 
        </div>
    </div>
    
  </div>
</template>

<script>
import {apiBaseUrl} from '@/config/env.js'
export default {
  data() {
    return {
      qrImage: '',
      invite: '',
      apiBaseUrl: apiBaseUrl
    }
  },
  methods: {
    init() {

      this.$api.shareCode({}).then(res => {
        if(res.status) {
          this.invite = res.data
        }
      })


      let data =  {
        client: 1,
        page: 1,
        params: {store: localStorage.getItem('businessId') - 0},
        token: this.$storage.get('userToken'),
        type: 2,
        url: apiBaseUrl + "wap/pages/share/jump"
      }
      this.$api.share(data).then(res => {
        if(res.status) {
          this.qrImage = res.data
        }
      })
    },
  },
  created() {
    this.init()
  }
}
</script>

<style lang="scss" scoped>
.qr {
  display: flex;
  .title {
    font-size: 12px;
    margin-top: 10px;
  }
}
img {
  width: 200px;
  height: 200px;
}
.url{
    font-size: 12px;
    padding: 18px 24px;
    background-color: #fafafa;
    border: 1px solid #eaeefb;
    border-radius: 4px;
}
.url-wrap {
  display: flex;
  align-items: center;
  margin-top: 20px;
}
</style>